/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
} from './PalAuthSubmission';

/**
 * 
 * @export
 * @interface GetLatestPalSubmission200Response
 */
export interface GetLatestPalSubmission200Response {
    /**
     * 
     * @type {PalAuthSubmission}
     * @memberof GetLatestPalSubmission200Response
     */
    data?: PalAuthSubmission;
}

/**
 * Check if a given object implements the GetLatestPalSubmission200Response interface.
 */
export function instanceOfGetLatestPalSubmission200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetLatestPalSubmission200ResponseFromJSON(json: any): GetLatestPalSubmission200Response {
    return GetLatestPalSubmission200ResponseFromJSONTyped(json, false);
}

export function GetLatestPalSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLatestPalSubmission200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalAuthSubmissionFromJSON(json['data']),
    };
}

export function GetLatestPalSubmission200ResponseToJSON(value?: GetLatestPalSubmission200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalAuthSubmissionToJSON(value.data),
    };
}

